<template>
  <div class="communicationTable">
    <p class="title">{{ tableName }}</p>
    <el-table :data="table" border>
      <el-table-column label="大纲" align="center" width="400">
        <template v-slot="scope">
          <div class="control" v-if="scope.row.isShowOutlineInput">
            <el-input v-model="scope.row.outline" maxlength="8" show-word-limit />
            <el-button type="primary" size="mini" @click="saveTableItem(scope.row, 'outline')">
              保存
            </el-button>
          </div>
          <div class="text" v-else @click="handleTextClick(scope.row, 'outline')">
            <span v-if="scope.row.outline">{{ scope.row.outline }}</span>
            <i class="icon-jr-icon-note" v-else />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="内容" align="center">
        <template v-slot="scope">
          <div class="control" v-if="scope.row.isShowContentInput">
            <el-input v-model="scope.row.content" />
            <el-button type="primary" size="mini" @click="saveTableItem(scope.row, 'content')">
              保存
            </el-button>
          </div>
          <div class="text" v-else @click="handleTextClick(scope.row, 'content')">
            <span v-if="scope.row.content">{{ scope.row.content }}</span>
            <i class="icon-jr-icon-note" v-else />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template v-slot="{ row }">
          <icon-and-button
            title="删除"
            :extraInfo="{ id: row.id }"
            :iconStyle="{ color: '#FA5050' }"
            icon="icon-jr-icon-delete"
            @handleControl="handleControl"
          />
        </template>
      </el-table-column>
    </el-table>
    <icon-and-button
      class="add"
      title="添加"
      :iconStyle="{ color: '#17757A' }"
      :buttonStyle="{ color: '#17757A' }"
      icon="icon-jr-icon-add"
      @handleControl="handleControl"
    />
  </div>
</template>

<script>
import IconAndButton from '@/components/IconAndButton.vue'
export default {
  props: {
    table: {
      type: Array,
      default: () => []
    },
    tableName: {
      type: String,
      default: ''
    }
  },

  components: {
    IconAndButton
  },

  methods: {
    handleControl(name, val) {
      if (name === '添加') {
        this.$emit('addTableItem', this.tableName)
      } else {
        this.$emit('deleteTableItem', val.id)
      }
    },
    saveTableItem(row, name) {
      this.$emit('saveTableItem', row, name)
    },
    handleTextClick(row, name) {
      this.$emit('handleTextClick', row, name)
    }
  }
}
</script>

<style lang="less" scoped>
.communicationTable {
  .title {
    color: #17757a;
    font-size: 22px;
    font-weight: 700;
    padding: 20px 0;
  }
  .add {
    border: 1px solid #ebeef5;
    border-top: none;
    height: 48px;
  }
  .control {
    display: flex;
    align-items: flex-end;
    padding: 0 20px;
    /deep/ .el-button {
      min-width: 56px;
      margin-left: 10px;
    }
  }
  .text {
    cursor: pointer;
    .icon-jr-icon-note {
      color: #17757a;
    }
  }
  /deep/.is-center {
    color: #333333;
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
